window.addEventListener("hashchange", function () {
  if (window.location.hash.startsWith("#kl-")) {
    // Remove the prefix "#kl-" to extract the popup ID
    let popupId = window.location.hash.replace("#kl-", "");
    history.replaceState(null, '', window.location.pathname);
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(["openForm", popupId]);
  } else if (window.location.hash === "#free-samples") {
    openSamplesPopup();
  } else if (window.location.hash === "#hide-popup") {
    const observer = new MutationObserver(() => {
      const styleElement = document.getElementById("site-blocker");
      if (styleElement) {
        styleElement.remove();
        observer.disconnect(); // Stop observing after removal
      }
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
    });
  }

  // Remove the hash from the URL without reloading the page.
  // history.replaceState(null, document.title, window.location.pathname + window.location.search);
});

document.addEventListener("DOMContentLoaded", function () {
  if (window.location.hash === "#select-samples") {
    openSamplesPopup();
  }
  if (window.location.hash.startsWith("#kl-")) {
    // Remove the prefix "#kl-" to extract the popup ID
    let popupId = window.location.hash.replace("#kl-", "");
    setTimeout(() => {
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(["openForm", popupId]);
    }, 2000); // 2000 milliseconds = 2 seconds
  }
});

function openSamplesPopup() {
  const freeSampleButton = document.querySelector(
    'a[data-action="select-samples"]'
  );

  if (freeSampleButton) {
    document.querySelector(".needsclick")?.parentNode?.remove();
    freeSampleButton.click();
  } else {
    console.warn("No free sample button found to trigger.");
  }
}

/**
 * Swatch-interest tracking.
 *
 * When free fabric swatches are added to cart while a product page is being
 * viewed, record that product as a custom Klaviyo event (its own metric) and
 * write it onto the Klaviyo profile (last-write-wins) so it is usable as a
 * person property inside other flows. Off a product page there is no viewed-
 * product context, so nothing fires.
 */
const swatchInterestFired = new Set();

/**
 * Read the currently viewed product from the PDP data blob rendered by
 * `snippets/track-product-view.liquid`. Returns null off a product page (the
 * blob only exists on the main product section), so callers can no-op silently.
 * @returns {{id, name, url, image, handle, description, price}|null}
 */
function getViewedProductForSwatchInterest() {
  const dataScript = document.getElementById("track-product-view-data");
  if (!dataScript) return null;

  let item;
  try {
    item = JSON.parse(dataScript.textContent).item;
  } catch (error) {
    return null;
  }
  if (!item || !item.product || !item.product.id) return null;

  return {
    id: item.product.id,
    name: item.product.title,
    url: toAbsoluteUrl(item.product.url),
    image: toAbsoluteUrl(item.product.image),
    handle: item.product.handle,
    description: item.product.description,
    // `price.amount` is Shopify's minor unit (pennies) — convert to whole pounds.
    price: item.price ? item.price.amount / 100 : null,
  };
}

/**
 * Normalise a Shopify relative (`/products/...`) or protocol-relative
 * (`//cdn...`) URL to an absolute one so it is usable inside a Klaviyo flow.
 * @param {string} url
 * @returns {string}
 */
function toAbsoluteUrl(url) {
  if (!url) return url;
  if (url.startsWith("//")) return `https:${url}`;
  if (url.startsWith("/")) return `${window.location.origin}${url}`;
  return url;
}

/**
 * Fire the swatch-interest Klaviyo event and profile update for the currently
 * viewed product. No-ops off a product page, when it has already fired for this
 * product on this page load, or when Klaviyo is unavailable. Wrapped so it can
 * never throw into or block the add-to-cart flow that calls it.
 */
function trackSwatchInterest() {
  try {
    const product = getViewedProductForSwatchInterest();
    if (!product) return;
    if (swatchInterestFired.has(product.id)) return;

    const klaviyo = (window.klaviyo = window.klaviyo || []);
    if (typeof klaviyo.push !== "function") return;

    klaviyo.push([
      "track",
      "Added Swatches For Product",
      {
        ProductID: product.id,
        ProductName: product.name,
        ProductURL: product.url,
        ProductImage: product.image,
        ProductHandle: product.handle,
        ProductDescription: product.description,
        Price: product.price,
      },
    ]);

    klaviyo.push([
      "identify",
      {
        "Last Swatch Product Name": product.name,
        "Last Swatch Product URL": product.url,
        "Last Swatch Product Image": product.image,
        "Last Swatch Product Description": product.description,
        "Last Swatch Product Price": product.price,
      },
    ]);

    swatchInterestFired.add(product.id);
  } catch (error) {
    console.warn("Swatch interest tracking failed", error);
  }
}

window.trackSwatchInterest = trackSwatchInterest;
